import "./ColoredLetter.scss"


interface ColoredLetterProps {
  letter: string
  baseHSL?: [number, number, number]
  backgroundColor?: string
  letterColor?: string
}

function ColoredLetter(props: ColoredLetterProps) {
  const [h, s, l] = props.baseHSL ?? [255, 50, 50]

  const alphabet = "abcdefghijklmnopqrstuvwxyz".split("")

  const letterIndex = alphabet.indexOf(props.letter.toLowerCase())
  const letterBackground = props.backgroundColor ?? `hsl(${ h / alphabet.length * letterIndex } ${ s }% ${ l }%)`

  return (
    <span className="colored-letter" style={{ backgroundColor: letterBackground, fontSize: "24px", color: props.letterColor }}>{props.letter}</span>
  )
}

export default ColoredLetter
